import { useCombineSelector, useWallet } from '@/services';
import { loadTokenInfo, REDUCER_NAME, ContextTokens } from '@/services/reducers/token';
import { ReactElement, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

declare interface TokenSpanProps {
    token: string; // 名称或者地址
}

const LoadingText = '...';

const TokenName = (props: TokenSpanProps): ReactElement => {
    const { chain } = useWallet();
    const [counter] = useCombineSelector<TokenRecuderContext>(REDUCER_NAME, (state) => [state.counter]);
    const [symbol, setSymbol] = useState(LoadingText);
    const dispatch = useDispatch();
    useEffect(() => void dispatch(loadTokenInfo(props.token)), [chain, props.token]);
    useEffect(() => {
        if (!chain || !ContextTokens[chain.name]) {
            setSymbol(LoadingText);
            return;
        }
        const tokenInfo = ContextTokens[chain.name][props.token] as Erc20TokenInfo;
        if (!tokenInfo) {
            setSymbol(LoadingText);
            return;
        }
        setSymbol(tokenInfo.symbol);
    }, [counter, chain, props.token]);

    return <>{symbol.toUpperCase()}</>;
};

export default TokenName;
